var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{key:"signUpBtn",staticClass:"mt-6 red-button-sm w-full",attrs:{"type":"button"},on:{"click":function($event){return _vm.signIn('register')}}},[_vm._v("Sign up")])}
var staticRenderFns = []

export { render, staticRenderFns }